import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import useEmpMapSubmission from "./useEmpMapSubmission";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import RecommendationRemarksComponent from "../RecommendationComponent";
import { innerInspRecommendation, siteInspRecommendation } from "../../citizen/TCPForms/data";
import DetailInfoTable from "../AllViewRemarks";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import DrawingsSection from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DrawingsSection";
import BasicSiteInspectionReport from "../ScheduleInspection/basicSiteInspectionReport";
import PaymentHead from "./PaymentHead";
import PaymentMemoTable from "../AllViewRemarks/PaymentChallan/PaymentMemoDetails";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import ActionButtons from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ActionButtons";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import ChatBoard from "../../../components/ChatBoard";
import CustomLetter from "../ReusableComponets/CustomLetter";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Box, Button, OutlinedInput, Select, FormControl } from "@mui/material";
import NewsTicker from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/TCP-HP/NewsTicker";
import { StyledMenuItem } from "../../citizen/TCPForms/forms/StyledComponents";
import LandUseNOC from "../../../components/LandUseNOC/LandUseNOC";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import DrawingsDetailsTable from "../AllViewRemarks/DrawingsTable";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";
import SubStep1 from "../../citizen/AVPForms/formComponents/revalidation/Step1/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/revalidation/Step1/SubStep3";
import SubStep2 from "../../citizen/AVPForms/formComponents/revalidation/Step1/SubStep2";
import SubStep4 from "../../citizen/AVPForms/formComponents/revalidation/Step1/SubStep4";
import Step4 from "../../citizen/AVPForms/formComponents/revalidation/Step4";
import Step3 from "../../citizen/AVPForms/formComponents/revalidation/Step3";

const RevalMapSubmissionPortal = ({ formData, refetch, submitAction, workflowDetails, userRolesArray }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray?.[0]?.code);
  const [uploadedFile, setUploadedFile] = useState(null);

  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);
  const isHideAction = ["REVERT_TO_APPLICANT", "APPROVED"]?.includes(formData?.status) && !isCitizen;
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    // { label: "NOC Status" },
    { label: "Fees" },
  ];
  const subTabDocLabels = [{ label: "Mandatory Documents" }, { label: "Conditional Documents" }];
  const subTabNocLabels = [{ label: "NOC Status" }, { label: "Select NOC" }];
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab) => {
    setSelectedDocTab(nextSubTab);
  };

  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);

    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return <SubStep1 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 1:
          return <SubStep3 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 2:
          return <SubStep2 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 3:
          return <SubStep4 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 4:
          return <Step4 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return (
            <React.Fragment>
              <div className="view-doc-container">
                <Button
                  variant="contained"
                  className="view-doc-btn"
                  onClick={handleDocView}
                  style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
                >
                  <span className="view-doc-icon">
                    <ViewSidebarIcon />
                  </span>
                  {currentView === "documents" ? "View all documents" : "View document section"}
                </Button>
              </div>
              {currentView === "documents" ? (
                <React.Fragment>
                  <DocumentSection
                    formData={params}
                    handleChange={handleTabChange}
                    setUpdatedDocuments={setUpdatedDocuments}
                    updatedDocuments={updatedDocuments}
                    setIsPreviewLoading={setIsPreviewLoading}
                    setDataRecommendation={setDataRecommendationDocument}
                    onSelect={onSelect}
                    handleNoWorkflow={handleNoWorkflow}
                    attachedDocs={params?.documents || formData?.documents}
                    docType="mandatory"
                    ComposableComponent={(props) => (
                      <RecommendationRemarksComponent
                        title="Recommendation Details"
                        label="Recommendation"
                        name="recommendation" // just a field name, not value!
                        options={SortingAlphabatically(siteInspRecommendation)}
                        defaultValue={dataRecommendationDocument}
                        extraLabel="Remarks"
                        setDeveloperRemarks={setDeveloperRemarksDocument}
                        developerRemarks={developerRemarksDocument}
                        setDataRecommendation={setDataRecommendationDocument}
                        {...props} // this includes `control`, injected later
                      />
                    )}
                  />
                  {!isCitizen && <DetailInfoTable detailData={documentRemarksData?.DetailDataRemarks} type="documentDetails" />}
                </React.Fragment>
              ) : (
                <ViewDocuments
                  documentSection={documentSection}
                  setIsPreviewLoading={setIsPreviewLoading}
                  iframeSrc={iframeSrc}
                  setIframeSrc={setIframeSrc}
                  initialUrl={initialUrl}
                />
              )}
            </React.Fragment>
          );
        case 1:
          return (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={formData?.documents}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                handleNoWorkflow={handleNoWorkflow}
                attachedDocs={params?.documents || formData?.documents}
                docType="conditional"
              />
            </React.Fragment>
          );
        default:
          return null;
      }
    } else if (activeTab === 2) {
      return <Step3 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />;
    } else if (activeTab === 3) {
      return (
        <React.Fragment>
          <BasicSiteInspectionReport
            formData={formData}
            setCurrentTab={handleTabChange}
            setUpdatedInspectionReportData={setUpdatedInspectionReportData}
            callInspectionDetailsAPI={callInspectionDetailsAPI}
            userRolesArray={userRolesArray}
          />
          <DetailInfoTable detailData={siteInspectionRemarksData?.DetailDataRemarks} type="inspectionDetails" formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 4) {
      return (
        <React.Fragment>
          <PaymentHead
            tenantId={tenantId}
            formData={params}
            setTaxHead={setTaxHead}
            taxHead={taxHead}
            empRole={userRolesArray?.[0]?.code}
            isFeesEligible={isFeesEligible}
            onSelect={onSelect}
            Modal={Modal}
          />
          <PaymentMemoTable formData={formData} />
          <RecommendationRemarksComponent
            title="Recommendation Details"
            label="Recommendation"
            name="recommendation" // just a field name, not value!
            options={SortingAlphabatically(siteInspRecommendation)}
            defaultValue={dataRecommendation}
            extraLabel="Remarks"
            setDeveloperRemarks={setDeveloperRemarks}
            developerRemarks={developerRemarks}
            setDataRecommendation={setDataRecommendation}
            buttonshow={true}
            onSaveClick={callPaymentDetailsAPI} // <-- parent callback
          />
          <DetailInfoTable detailData={paymentHeadRemarksData?.DetailDataRemarks} type="paymentDetails" />
        </React.Fragment>
      );
    } else if (!isHideAction && activeTab === 5) {
      return (
        <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName={"Map Submission"} />
          <CollapsibleHistory
            formData={formData}
            callNotingDetailsAPI={callNotingDetailsAPI}
            developerRemarks={developerRemarks}
            setDeveloperRemarks={setDeveloperRemarks}
            notingRemarksData={notingRemarksData}
          />
          {/* <React.Fragment>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
              <Box gridColumn="span 2" style={{ display: "flex" }}>
                <b style={{ marginRight: "2px" }}>Action </b>
              </Box>
              <Box gridColumn="span 10">
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <Select
                    // displayEmpty
                    value={currentAction || mapSubmissionAction}
                    label="Select Action"
                    onChange={onDropDownSelect}
                    sx={{ width: "18.25vw", borderRadius: "1px" }}
                    size="small"
                    variant="outlined"
                    required={false}
                    input={<OutlinedInput />}
                    renderValue={(selected) => {
                      if (selected && selected.length === 0) {
                        return <em>Select Action</em>;
                      }
                      return selected.action;
                    }}
                  >
                    <StyledMenuItem disabled value="" key="Select Action">
                      <em>Select Action</em>
                    </StyledMenuItem>
                    {actions &&
                      actions?.map((item) => {
                        const dropdowns = item?.action;
                        return (
                          <StyledMenuItem value={item} key={dropdowns}>
                            {dropdowns}
                          </StyledMenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </React.Fragment> */}
          <OnSelectActionDropdown currentAction={currentAction || mapSubmissionAction || " "} onChange={onDropDownSelect} actions={actions} />
          <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />
        </React.Fragment>
      );
    } else if ((!isHideAction && activeTab === 6) || (isHideAction && activeTab === 5)) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} />
        </React.Fragment>
      );
    } else if ((!isHideAction && activeTab === 7) || (isHideAction && activeTab === 6)) {
      return (
        <React.Fragment>
          <ChatBoard formData={formData} assignerToChatboard={workflowDetails?.data?.processInstances} />
        </React.Fragment>
      );
    } else if ((!isHideAction && activeTab === 8) || (isHideAction && activeTab === 7)) {
      return (
        <React.Fragment>
          <CustomLetter
            formData={formData}
            setCustomLetter={setCustomLetter}
            setTypeOfLetter={setTypeOfLetter}
            workflowDetails={workflowDetails}
            userRolesArray={userRolesArray}
          />
        </React.Fragment>
      );
    }
  };

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <EmpTopBar formData={formData} />
      <NewsTicker textForNews="Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly." />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          {/* <PrimaryTab label="NOC Status" /> */}
          {/* <PrimaryTab label="Select NOC" /> */}
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="Site Inspection" />
          <PrimaryTab label="Payment Heads" />
          {!isHideAction && <PrimaryTab label="Take Action" />}
          <PrimaryTab label="All Remarks" />
          <PrimaryTab label="Chat Board" />
          {/* <PrimaryTab label="Letter" /> */}
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {activeTab === 1 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedDocTab}
            onChange={(e, i) => handleSubDocTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabDocLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}

      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default RevalMapSubmissionPortal;
